import React, { Component } from 'react';
import '../componentform.css';
import componentFormService from '../ComponentFormService.js';
import componentMap from '../../../ComponentMap';
import ImageGalleryField from '../../../ImageGalleryField';
import { showNotification } from '../../../StatusNotification';
import { showConfirmation } from '../../../ConfirmationModal';

export class BigText5050Form extends Component {
    static displayName = BigText5050Form.name;

    constructor(props) {
        super(props);
        this.state = {
            bigText5050: null,
            formType: null,
            pageId: this.props.pageId,
            versionId: this.props.versionId,
            versionStatus: this.props.versionStatus
        };
    }

    componentDidMount() {
        this.getComponentData();
    }

    handleChange = (e) => {
        let newBigText5050 = this.state.bigText5050;
        newBigText5050[e.target.name] = e.target.value;
        this.setState({ bigText5050: newBigText5050 });
    }

    handleSubmit = (e) => {
        e.preventDefault();

        let bigText5050 = this.state.bigText5050;
        bigText5050.versionId = this.state.versionId;
        bigText5050.pageId = this.state.pageId;
        let url = this.state.formType == "Update" ? "UpdateBigText5050" : "CreateBigText5050";
        fetch('Admin/' + url, {
            method: 'POST',
            body: JSON.stringify(bigText5050),
            headers: {
                'Content-Type': 'application/json',
                'Accept': 'application/json'
            }
        }).then(
            response => response.json()
        ).then(
            data => {
                if (!isNaN(data)) {
                    var pageComponentId = this.props.pageComponentId != undefined ? this.props.pageComponentId : 0;
                    var isDataSaved = componentFormService.managePageComponent(this.state.pageId, "BigText5050", parseInt(data), parseInt(pageComponentId), this.state.versionId, this.state.versionStatus);
                    
                    //window.location = '/UpdatePageComponent/' + this.state.pageId;
                    this.props.onComponentSaved();
                }
                else {
                    showNotification(data, "error");
                }
            }
        );
    }

    render() {
        let deleteButton = this.state.formType == "Update" ? <button className='delete-btn' onClick={this.deleteComponent.bind(this)}>Delete</button> : null;
        let title = null;
        let body = null;
        let imageLink = null;
        let componentName = null;

        if (this.state.bigText5050 != null) {
            let bigText5050 = this.state.bigText5050;
            title = bigText5050.title;
            body = bigText5050.body;
            imageLink = bigText5050.imageLink;
            componentName = bigText5050.componentName;
        }

        let wrapperClasses = this.state.versionStatus == 'draft' ? 'grid-wrapper component-form' : 'grid-wrapper component-form disable-form';
        let isImageGalleryFieldDisabled = this.state.versionStatus == 'draft' ? false : true;
        return (
            <form onSubmit={this.handleSubmit} className={wrapperClasses}>
                <div className='dual-grid'>
                    <div className='dual-grid__1-2 form-title'>
                        <h2>{componentName} {componentMap.componentTypeDisplay('BigText5050')}</h2>
                    </div>

                    <label htmlFor='bigText5050-componentName'>Component Name:</label>
                    <input id='bigText5050-componentName' name='componentName' type='text' defaultValue={componentName} onChange={this.handleChange} required maxLength='15' />

                    <label htmlFor='bigText5050-title'>Title: </label>
                    <input id='bigText5050-title' name='title' type='text' defaultValue={title} onChange={this.handleChange} required />

                    <label htmlFor='bigText5050-body'>Body: </label>
                    <textarea id='bigText5050-body' name='body' rows="4" value={body} onChange={this.handleChange} required ></textarea>

                    <label>Image Link: </label>
                    <input name='imageLink' type='text' defaultValue={imageLink} onChange={this.handleChange} required hidden />
                    <ImageGalleryField name='imageLink' currentImageUrl={imageLink} handleImageChange={this.handleChange} isDisabled={isImageGalleryFieldDisabled} />

                    <div className='dual-grid__1-2'>
                        <button type='submit'>Save</button>
                        {deleteButton}
                    </div>
                </div>
            </form>
        );
    }

    async getComponentData() {
        let componentId = (this.props.componentId !== undefined) ? this.props.componentId : 0;
        let formType = this.props.formType !== undefined ? this.props.formType : 'Create';

        const response = await fetch('Admin/GetBigText5050?componentId=' + componentId, {
            method: 'GET',
            headers: {
                'Content-Type': 'application/json',
                'Accept': 'application/json'
            }
        });

        const data = await response.json();

        this.setState({
            bigText5050: data,
            formType: formType
        });
    }

    async deleteComponent(e) {
        e.preventDefault();
        let confirmDelete = await showConfirmation("Are you sure you want to delete this component and remove all associations to it?");

        if (confirmDelete) {
            const response = await fetch('Admin/DeleteBigText5050?componentId=' + this.state.bigText5050.id, {
                method: 'DELETE',
                headers: {
                    'Content-Type': 'application/json',
                    'Accept': 'application/json'
                }
            });

            const data = await response.json();

            if (data === "Deleted") {
                //window.location = '/UpdatePageComponent/' + this.state.pageId;
                this.props.onComponentDeleted();
            }
            else {
                showNotification(data, "error");
            }
        }
    }
}

export default BigText5050Form;